export const create = {
  createSuccessfully: '管理者情報が登録されました。',
}
